import React from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import styles from "./styles/pos-warning.css.js";
import withStyles from "components/with-styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import Icon from "components/icon";

const PosWarning = ({classes, intl, maxX, maxY}) => {
    return <div className={classes.warning}>
        <Icon className={classes.icon} name="warning"/>
        <FormHelperText className={classes.message}>
            {intl.formatMessage({id: "app.form.posrange.warning"}, {maxX, maxY})}
        </FormHelperText>
    </div>
}

PosWarning.propTypes = {
    /**
     * Object with the size of the image, in px
     **/
    pos: PropTypes.object,
};

export default withStyles(styles)(injectIntl(PosWarning));
